import { render, staticRenderFns } from "./Ordc01ErrorComponent.vue?vue&type=template&id=6b40582b&scoped=true&"
import script from "./Ordc01ErrorComponent.vue?vue&type=script&lang=ts&"
export * from "./Ordc01ErrorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40582b",
  null
  
)

export default component.exports